module.exports = __webpack_public_path__ + "static/media/logo.d952f891.png";